<div class="flex flex-col gap-1.5">
  <ng-container *ngFor="let option of options; let i = index">
    <div [ngClass]="{ 'option-card': !isProductCard }" *ngIf="(i === step && isProductCard) || !isProductCard">
      <div class="option-label">
        <span class="option-name">{{ option.name }}:</span>
        <span class="option-value">{{ optionsSelected[i] }}</span>
      </div>
      <app-variant-chips
        *ngIf="galleries || (galleryImages$ | async)"
        [options]="option.values"
        [properties]="options"
        [name]="option.name"
        [selected]="optionsSelected[i]"
        [available]="available[i]"
        (changes)="onChanges(i, $event)"
        (nextStep)="nextStep()"
        [galleries]="galleries"
        [variants]="variants"
        [selectedVariant]="selected"
        [isProductCard]="isProductCard"
        [optionsSelected]="optionsSelected"
        (restartVariantSelected)="selectDefaultVariant()"
      >
      </app-variant-chips>
    </div>
  </ng-container>
</div>
